import { render, staticRenderFns } from "./LmProcessNewOrEdit-2.vue?vue&type=template&id=3bb0e5e2&scoped=true&"
import script from "./LmProcessNewOrEdit-2.vue?vue&type=script&lang=js&"
export * from "./LmProcessNewOrEdit-2.vue?vue&type=script&lang=js&"
import style0 from "./LmProcessNewOrEdit-2.vue?vue&type=style&index=0&id=3bb0e5e2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb0e5e2",
  null
  
)

export default component.exports